import {
    apiRequest,
    polaKerjaDetail,
    jamKerjaCreate,
    jamKerjaList
} from "../../../../../services/adapters/kepegawaian/polaKerjaService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", polaKerjaDetail, {
            params: query
        }, true)
    }

    fetchCreate = async (query) => {
        return await apiRequest("post", jamKerjaCreate, {
            body: query
        }, true)
    }

    fetchList = async (query) => {
        return await apiRequest("get", jamKerjaList, {
            params: query
        }, true)
    }
}

export default UpdateRepository